import { useT } from '@repo/ui/hooks'
import { Select, SelectTrigger } from '@repo/ui/select'
import { SelectValue } from '@repo/ui/select'
import { SelectContent } from '@repo/ui/select'
import { SelectItem } from '@repo/ui/select'

import { FormType } from '../../types'

export function SelectModeButton({
  form,
  dimensionIndex,
}: {
  form: FormType
  dimensionIndex: number
}) {
  const { t } = useT({ keyPrefix: 'admin.insights.form.dimensions.buckets.number' })

  const mode = form.watch('dimensionModes')[dimensionIndex]!.number ?? 'simple'

  const updateMode = (mode: 'simple' | 'range') => {
    const dimensionModes = form.getValues('dimensionModes')
    dimensionModes[dimensionIndex]!.number = mode
    form.setValue('dimensionModes', [...dimensionModes])
  }

  return (
    <Select value={mode} onValueChange={(value) => updateMode(value as 'simple' | 'range')}>
      <SelectTrigger>
        <SelectValue placeholder={t('modePlaceholder')} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="simple">{t('modeOptions.simple')}</SelectItem>
        <SelectItem value="range">{t('modeOptions.range')}</SelectItem>
      </SelectContent>
    </Select>
  )
}
